// extracted by css-extract-rspack-plugin
export default {"container":"_32YUbmef9NrL5lipZvefTq","content":"_3S6SwlAcm8XGv1oAvO5V3I"};